import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const token = localStorage.getItem("jx_token");
    if (!token) { setUser(null); return null; }
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      localStorage.removeItem("jx_token");
      setUser(null);
      return null;
    }
  };

  useEffect(() => { (async () => { await refresh(); setLoading(false); })(); }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("jx_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const register = async (email, password, username) => {
    const r = await api.post("/auth/register", { email, password, username });
    localStorage.setItem("jx_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };
  const logout = () => { localStorage.removeItem("jx_token"); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, setUser, refresh, login, register, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
